// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetRecipientViewResponse {
    static getAttributeTypeMap() {
        return GetRecipientViewResponse.attributeTypeMap;
    }
}
GetRecipientViewResponse.discriminator = undefined;
GetRecipientViewResponse.additionalProperties = false;
GetRecipientViewResponse.attributeTypeMap = [
    {
        "name": "url",
        "baseName": "url",
        "type": "string"
    },
];
//# sourceMappingURL=getRecipientViewResponse.js.map